/* eslint-disable react/prop-types */
import classes from "./composed-view-workflow.module.scss";
import Label from "@/components-library/widgets/label";
import Flex from "@/components-library/layout/flex";
import CardViewWorkflowStep from "@/composed-views/card-view-workflow-step";
import Grid from "@/components-library/layout/grid";
function ComposedViewWorkflow({
  header,
  title,
  content,
  stepOne,
  stepTwo,
  stepThree,
  stepFour,
}) {
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 768;
  const DesktopList = (
    <>
      <Grid columns="1fr 1fr" className={classes.firstRow}>
        <CardViewWorkflowStep step={stepOne} />
        <CardViewWorkflowStep step={stepTwo} />
      </Grid>
      <Grid columns="1fr 1fr">
        <CardViewWorkflowStep step={stepThree} />
        <CardViewWorkflowStep step={stepFour} />
      </Grid>
    </>
  );
  const MobileList = (
    <>
      <Grid columns="1fr">
        <CardViewWorkflowStep step={stepOne} />
        <CardViewWorkflowStep step={stepTwo} />
        <CardViewWorkflowStep step={stepThree} />
        <CardViewWorkflowStep step={stepFour} />
      </Grid>
    </>
  );
  return (
    <Flex
      align="flex-start"
      direction="column"
      justify="flex-start"
      className={classes.container}
    >
      {header && (
        <Label
          weight="bold"
          tag="h5"
          color="primary"
          align="start"
          className={classes.header}
        >
          {header}
        </Label>
      )}

      <Label
        weight="bold"
        tag="h2"
        color="secondary"
        align="start"
        className={classes.title}
      >
        {title}
      </Label>
      {content && (
        <Label align="start" size="md" color="secondary">
          {content}
        </Label>
      )}

      {isMobile ? MobileList : DesktopList}
    </Flex>
  );
}

export default ComposedViewWorkflow;
